import { getPreviousDate } from "../components/utils/dateFormate"
import apiService from "./api"

export const authorService = async (domainName,date=getPreviousDate(),limit=5,page=1,  dynamicParams = {},token) => {
    const queryParams = new URLSearchParams({
      limit,
      pageNo: page,
      domain: domainName,
      startDate:date,
      ...dynamicParams,
    });
    console.log('queryParams.toString()', queryParams.toString());
    
     const url = `/api/v1/admin/get-authors-list?${queryParams.toString()}`
    try {
        const response = await apiService.get(url, {}, token);
        return response.data
    } catch (error) {
        throw error;
    }
}